import type { ComponentProps } from 'react';

import { cn } from '../cn';

/** The house, stroked in currentColor where the source hard-codes black. */
export const HomeIcon = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg
    viewBox='0 0 36 36'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden
    className={cn('size-6', className)}
    {...props}>
    <path
      d='M3 15.5L7.36002 12.1498L17.3919 4.46576C17.7507 4.19093 18.2493 4.19093 18.6081 4.46576L28.64 12.1498L33 15.5M12.68 31H9.36002C8.25545 31 7.36002 30.1046 7.36002 29V18.2144C7.36002 17.9047 7.50348 17.6125 7.7485 17.4232L17.3885 9.97263C17.7487 9.69427 18.2514 9.69427 18.6115 9.97263L28.2515 17.4232C28.4966 17.6125 28.64 17.9047 28.64 18.2144V29C28.64 30.1046 27.7446 31 26.64 31H23.32H22.66C21.5554 31 20.66 30.1046 20.66 29V24.3617C20.66 23.8094 20.2123 23.3617 19.66 23.3617H16.34C15.7877 23.3617 15.34 23.8094 15.34 24.3617V29C15.34 30.1046 14.4446 31 13.34 31H12.68Z'
      stroke='currentColor'
      strokeWidth={3}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
